import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';

type Payload = Parameters<typeof API.deliveries.cancelTurnaround>[0];

export const useCancelTurnaround = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: Payload) => API.deliveries.cancelTurnaround(payload),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: [QueryKeys.TurnaroundList] }),
        queryClient.invalidateQueries({ queryKey: [QueryKeys.Delivery] }),
        queryClient.invalidateQueries({ queryKey: [QueryKeys.TimeStamps] }),
        queryClient.invalidateQueries({ queryKey: [QueryKeys.SurgeryTimeStamps] }),
      ]),
  });
};
